import {Routes} from '@angular/router';
import {MessagingComponent} from './messaging.component';
import {AuthGuard} from '../core/security/auth-guard.service';
import {ModulesEnum} from '../core/security/modules.enum';
import {RolesEnum} from '../core/security/roles.enum';
import {MenuGroupEnum} from '../core/security/menu-group.enum';

export const routes: Routes = [
  {
    path: '',
    component: MessagingComponent,
    canActivate: [AuthGuard],
    data: {
      menuGroup: MenuGroupEnum.MessagingGroup,
      package: ModulesEnum.MessagingModule,
      permissions: [RolesEnum.Messaging_View, RolesEnum.Messaging_Edit, RolesEnum.Messaging_Delete],
      meta: {
        title: 'Basic SMS',
        override: true,
        description: 'Basic SMS Page',
        inSideMenu: true,
        iconClass: 'material-icons',
        iconClassCode: 'textsms',
      }
    }
  }
];
